import React from "react";
import styled from "@emotion/styled";

import { Typography } from "@mui/material";

import SidebarNavList from "./SidebarNavList";
import { useSidebarFade } from "./SidebarContext";

const Title = styled(Typography)`
  color: ${(props) => props.theme.sidebar.color};
  font-size: ${(props) => props.theme.typography.caption.fontSize};
  padding: ${(props) => props.theme.spacing(4)}
    ${(props) => props.theme.spacing(7)} ${(props) => props.theme.spacing(1)}
    ${(props) => props.theme.spacing(4.5)};
  text-transform: uppercase;
  white-space: nowrap;
  display: block;
`;

const SidebarNavSection = (props) => {
  const {
    title,
    pages,
    className,
    component: Component = "nav",
    ...rest
  } = props;
  const fade = useSidebarFade(0.4);
  return (
    <Component {...rest}>
      {title && (
        <Title variant="subtitle2" sx={fade}>
          {title}
        </Title>
      )}
      <SidebarNavList pages={pages} depth={0} />
    </Component>
  );
};

export default SidebarNavSection;
